import type { LoginStatus } from 'infrastructure/enums/login-status';
import type { IDoctorSelect } from 'infrastructure/interfaces';

export class DoctorSelect {
  guid: string;
  label: string;
  status: LoginStatus;

  constructor(data: IDoctorSelect) {
    this.guid = data.guid;
    this.label = data.label;
    this.status = data.record.status;
  }
}
